// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1_XVy","subheader":"ReorderModal_subheader__1nbGp","listWrap":"ReorderModal_listWrap__2n5jZ"};